import { fetchWithAuthHeader } from '../../auth';
import { jsonResponseHandling } from '../fetch';
import { apiUrl, TRAFFIC_PATH } from '../api-manager';

export const fetchRouteAlerts = async () => fetchWithAuthHeader(
    apiUrl(`${TRAFFIC_PATH}/monitoring/routes`),
    {
        method: 'GET',
    },
).then(response => jsonResponseHandling(response));

export const fetchRouteAlertDetailsById = async id => fetchWithAuthHeader(
    apiUrl(`${TRAFFIC_PATH}/monitoring/routes/${id}`),
    {
        method: 'GET',
    },
).then(response => jsonResponseHandling(response));

export const fetchRouteAlertDetailsByIds = async ids => fetchWithAuthHeader(
    apiUrl(`${TRAFFIC_PATH}/monitoring/routes/search`),
    {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(ids),
    },
).then(response => jsonResponseHandling(response));

export const fetchAllRouteAlertDetails = async () => fetchWithAuthHeader(
    apiUrl(`${TRAFFIC_PATH}/monitoring/routes/all`),
    {
        method: 'GET',
    },
).then(response => jsonResponseHandling(response));
